module.exports = __webpack_public_path__ + "static/img/9.a20ba51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9.jpg
// module id = VyWw
// module chunks = 0